export enum AppType {
    WindowsService = 'windows-service',
    LinuxService = 'linux-service',
    AppPool = 'apppool',
    ScheduledTask = 'scheduled-task',
    WebSite = 'website',
    VirtualApp = 'virtualapp',
}
